import { CapoPlugin } from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];